import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  value: null, // Başlangıçta null yapıyoruz ki verinin henüz gelmediğini bilelim
  isInitialized: false, // Paket yüklendi mi yüklenmedi mi kontrolü
};

export const selectClassSlice = createSlice({
  name: "selectClass", // "selectCalss" yazım hatası düzeltildi
  initialState,
  reducers: {
    selectClassValue: (state, action) => {
      state.value = action.payload;
      state.isInitialized = true; // Veri geldiğinde initialization tamamlandı diyoruz
    },
  },
});

export const { selectClassValue } = selectClassSlice.actions;

export default selectClassSlice.reducer;
